namespace TabAurous.Finance {
    export interface PDCClearanceRow {
        TransId?: number;
        VoucherNo?: string;
        InvoiceNo?: string;
        TransDate?: string;
        RefNo?: string;
        RefDate?: string;
        LedgerId?: number;
        LedgerName?: string;
        PDCTypeId?: number;
        PDCVoucherNo?: string;
        Type?: string;
        Amount?: number;
        ChequeNo?: string;
        ChequeDate?: string;
        AgainstId?: number;
        VoucherTypeId?: number;
        Narration?: string;
        Status?: string;
        CreatedBy?: number;
        FinancialYearId?: number;
        Details?: PDCClearanceDetailsRow[];
        ExtraDate?: string;
        Extra1?: string;
        Extra2?: string;
        CompanyId?: number;
    }

    export namespace PDCClearanceRow {
        export const idProperty = 'TransId';
        export const nameProperty = 'VoucherNo';
        export const localTextPrefix = 'Finance.PDCClearance';
        export const deletePermission = 'Finance:PDCClearance:Delete';
        export const insertPermission = 'Finance:PDCClearance:Add';
        export const readPermission = '*';
        export const updatePermission = 'Finance:PDCClearance:Edit';

        export declare const enum Fields {
            TransId = "TransId",
            VoucherNo = "VoucherNo",
            InvoiceNo = "InvoiceNo",
            TransDate = "TransDate",
            RefNo = "RefNo",
            RefDate = "RefDate",
            LedgerId = "LedgerId",
            LedgerName = "LedgerName",
            PDCTypeId = "PDCTypeId",
            PDCVoucherNo = "PDCVoucherNo",
            Type = "Type",
            Amount = "Amount",
            ChequeNo = "ChequeNo",
            ChequeDate = "ChequeDate",
            AgainstId = "AgainstId",
            VoucherTypeId = "VoucherTypeId",
            Narration = "Narration",
            Status = "Status",
            CreatedBy = "CreatedBy",
            FinancialYearId = "FinancialYearId",
            Details = "Details",
            ExtraDate = "ExtraDate",
            Extra1 = "Extra1",
            Extra2 = "Extra2",
            CompanyId = "CompanyId"
        }
    }
}
